module.exports = __webpack_public_path__ + "static/img/SA-Z9R.8e420685.jpg";